module.exports = __webpack_public_path__ + "static/assets/5dbf111a76a93a93613ec81c16dfc6d3.svg";